import {normalize, schema, denormalize} from 'normalizr';
import user from "./normalizeUsers";

const event = new schema.Entity('events', {user: user}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {events: [event]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = event;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = event;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default event;
